import { AssetCollection } from '@/features/AssetCollection/AssetCollection';
import { createFileRoute } from '@tanstack/react-router';

import { validateFilterSearch } from '@/lib/filterSearchParams';

export const Route = createFileRoute('/asset_collection/')({
    component: AssetCollection,
    validateSearch: validateFilterSearch,
});
